import type { ProductSlug } from 'types/cms/ProductSlug';

export const getReviewProductSlugs = (
  bundleProducts: { product: ProductSlug }[] | undefined,
  fallbackSlug: string,
): string[] =>
  bundleProducts?.length
    ? [...new Set(bundleProducts.map((item) => item.product.slug))]
    : [fallbackSlug];
